import axios from 'axios';
import { Loading } from 'element-ui';
import { Message } from 'element-ui';
import Router from '../router/index.js'
import { log, getToken, getUserId } from '@/assets/common.js'
//var baseUrl = "http://10.10.1.124:10014/"//本地
//var baseUrl = 'https://api.dev.ysintelligent.com' //开发环境
var baseUrl=baseUrl_global
var instance = axios.create({
	baseURL: baseUrl,
	timeout: 20000,
	headers: {
		'weiweiHeader': 'foobar66'
	}
});
//表单提交
export function ajaxform(type, url, formObj) {
	let loadingInstance = Loading.service({
		fullscreen: true
	});
	//转化formObj
	let resizeFormObj = {}
	let contentObj = {}
	for(let key in formObj) {
		let keyName = key
		let value = formObj[key]
		if(keyName.search("_content") == -1) {
			resizeFormObj[keyName] = value
		} else {
			contentObj[keyName] = value
		}
	}
	resizeFormObj.appContent = JSON.stringify(contentObj)
	resizeFormObj.appType = type
	//用户名和token
	resizeFormObj.appSubmitUserId = getUserId()
	resizeFormObj.token = getToken()
	
	let args = {
		data: JSON.stringify(resizeFormObj)
	}
	console.log(args,"表单参数")
	//promise
	let p = new Promise(function(resolve, reject) {
		instance({
			method: 'post',
			url: url,
			data: {
				...args
			},
		}).then(function(response) {
			loadingInstance.close();
			if(response.data.erroyCode == 200) {
				Message({
					message: "提交成功",
					type: 'success',
					duration: 1000,
					onClose: () => {
						Router.back()
					}
				});
				resolve(response.data)
			} else {
				if(response.data.erroyCode == -20000) {
					Message({
						message: '登录信息失效，重新登录',
						type: 'error',
						duration: 1000,
						onClose: () => {
							Router.push("/login")
						}
					});

				} else {
					Message({
						message: response.data.erroyMsg,
						type: 'error',
						duration: 1500
					});
				}
				reject(response.data)
			}
		}).catch(function(response) {
			loadingInstance.close();
			Message({
				message: "捕获异常",
				type: 'error',
				duration: 1500
			});
			reject(response.data)
		})
	})
	return p
}
//验证码
export function ajaxCode(phone) {
	//转化formObj
	let resizeFormObj = {}
	resizeFormObj.type = 2
	resizeFormObj.phone = phone
	let args = {
		data: JSON.stringify(resizeFormObj)
	}
	console.log(args)
	//promise
	let p = new Promise(function(resolve, reject) {
		instance({
			method: 'post',
			url: "/infoplatform/fashionuserinfo/RequestPhoneCode",
			data: {
				...args
			},
		}).then(function(response) {
			if(response.data.erroyCode == 200) {
				resolve(response.data)
			} else {
				reject(response.data)
			}
		}).catch(function(response) {
			reject(response.data)
			Message.error("捕获异常");
		})
	})
	return p
}
//登录
export function ajaxLogin(phone, code) {
	//转化formObj
	let formObj = {}
	formObj.phone = phone
	formObj.code = code
	formObj.token = ""
	formObj.userDeviceInfo = window.navigator.userAgent
	let args = {
		data: JSON.stringify(formObj)
	}
	console.log(args)
	//promise
	let p = new Promise(function(resolve, reject) {
		instance({
			method: 'post',
			url: "/infoplatform/fashionuserinfo/PhoneNumberLoginOrRegiste",
			data: {
				...args
			},
		}).then(function(response) {
			//			resolve(response.data)
			if(response.data.erroyCode == 200) {
				resolve(response.data)
			} else {
				reject(response.data)
			}
		}).catch(function(response) {
			Message.error("捕获异常");
			reject(response.data)
		})
	})
	return p
}
//cookie的token登录校验
export function ajaxToken(token) {
	//转化formObj
	let formObj = {}
	formObj.phone = ""
	formObj.code = ""
	formObj.token = token
	formObj.userDeviceInfo = window.navigator.userAgent
	let args = {
		data: JSON.stringify(formObj)
	}
	//promise
	let p = new Promise(function(resolve, reject) {
		instance({
			method: 'post',
			url: "/infoplatform/fashionuserinfo/PhoneNumberLoginOrRegiste",
			data: {
				...args
			},
		}).then(function(response) {
			//			resolve(response.data)
			if(response.data.erroyCode == 200) {
				resolve(response.data)
			} else {
				reject(response.data)
			}
		}).catch(function(response) {
			Message.error("捕获异常");
			reject(response.data)
		})
	})
	return p
}


// WEBPACK FOOTER //
// ./src/assets/request.js